var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGraduationCapFilled = function SvgGraduationCapFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.377 17.008a7.26 7.26 0 0 0 3.645.971v.002a7 7 0 0 0 3.519-.928L20 14.924v2.692a5.01 5.01 0 0 1-3.519 4.777c-1.456.42-2.966.625-4.481.608a15.6 15.6 0 0 1-4.48-.604A5.01 5.01 0 0 1 4 17.62v-2.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.047.977a5.23 5.23 0 0 1 2.635.74l7.375 3.512A3.77 3.77 0 0 1 24 8.48V20a1 1 0 0 1-2 0v-8.247l-7.4 3.536a5 5 0 0 1-2.577.693 5.3 5.3 0 0 1-2.7-.738l-7.38-3.514a3.69 3.69 0 0 1 0-6.5L9.4 1.672a5.2 5.2 0 0 1 2.647-.695"
  })));
};
export default SvgGraduationCapFilled;